import React from 'react';
import { useT } from '../../i18n';

// The two review clocks.
//
// A countdown on its own tells you when, not whether you need to do anything —
// so the monthly one carries the live breach count. "28 days, nothing to do" and
// "28 days, 3 positions out of band" are different situations and should not
// look identical.

function Clock({ label, date, days, detail, urgent }) {
    const { t, tn, fmt } = useT();
    return (
        <div className={`countdown${urgent ? ' is-urgent' : ''}`}>
            <span className="countdown__label">{label}</span>
            <span className="countdown__days">
                {days === 0 ? t('countdown.today') : tn('countdown.daysLeft', days)}
            </span>
            {/* Was a hardcoded English month array. Dates now follow the
                toggle: 2026. 9. 1. in Korean, Sep 1, 2026 in English. */}
            <span className="countdown__date">{fmt.date(date) ?? '—'}</span>
            {detail && <span className="countdown__detail">{detail}</span>}
        </div>
    );
}

export default function ReviewCountdown({ schedule, breachCount, leavingCount }) {
    const { t, tn } = useT();
    if (!schedule) return null;

    return (
        <div className="countdowns">
            <Clock
                label={t('countdown.bandCheck')}
                date={schedule.nextBandCheck}
                days={schedule.daysToBandCheck}
                urgent={breachCount > 0}
                detail={
                    breachCount > 0
                        ? tn('countdown.outsideBand', breachCount)
                        : t('countdown.withinBand')
                }
            />
            <Clock
                label={t('countdown.reconstitution')}
                date={schedule.nextReconstitution}
                days={schedule.daysToReconstitution}
                detail={
                    leavingCount > 0
                        ? tn('countdown.replaced', leavingCount)
                        : t('countdown.noChanges')
                }
            />
        </div>
    );
}
